import styled from "styled-components";
import { ReactComponent as SvgDotPatternIcon } from "../../../../images/svg-decorator-blob-2.svg";
import tw from "twin.macro";

export const SvgDotPattern1 = tw(
  SvgDotPatternIcon,
)`tw-absolute tw-bottom-0 tw-right-0 tw-transform tw-translate-y-2/3 tw-translate-x-1/2 -tw-z-10 tw-opacity-50 tw-text-primary-500 tw-fill-current tw-w-32`;
export const InformationContainerInner = tw.div`tw-absolute tw-bg-gray-200 tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-rounded-xl`;
export const Subheading = tw.div`tw-relative tw-text-lg lg:tw-text-xl tw-font-semibold tw-inline-block`;
export const Description = tw.div`tw-relative tw-mt-2`;
export const SpondGroupContainer = tw.div`tw-relative tw-mt-2  sm:tw-inline-flex tw-gap-x-4`;
export const SubmitButton = styled.button`
  ${tw`tw-mt-5 tw-tracking-wide tw-font-semibold tw-bg-primary-500 tw-text-gray-100 tw-px-8 tw-py-4 tw-rounded-lg hover:tw-bg-primary-900 tw-transition-all tw-duration-300 tw-ease-in-out tw-flex tw-items-center tw-justify-center focus:tw-shadow-outline focus:tw-outline-none`}
  .icon {
    ${tw`tw-w-6 tw-h-6 -tw-ml-2`}
  }
  .text {
    ${tw`tw-ml-3`}
  }
`;
